import { RECONCILIATION_TEAMS_URL } from "../helpers/routes";
import {
  handleResponse,
  getParams,
  getMultipartParams,
  surfaceServerErrors,
} from "../helpers/validate";
import notice from "../../utils/notice";

// TZ-784 reconciliation: one-time pass for the 14 active schools to map every
// existing Team (which has no sport_id since the 2021 migration that dropped
// the FK) to a master Sport. After backfill of student.sport_id is complete,
// this surface can be removed.

export const getUnmappedTeams = (
  setterFunction,
  page = 1,
  query = ""
) => {
  return fetch(
    `${RECONCILIATION_TEAMS_URL}?page=${page}&search_query=${query}`,
    getMultipartParams("GET")
  )
    .then((res) => handleResponse(res))
    .then((json) => setterFunction(json))
    .catch((e) => {
      notice("Error loading unmapped teams");
      console.error(e.errors);
      throw e;
    });
};

export const assignSportToTeam = (setterFunction, teamId, sportId) => {
  const jsonData = JSON.stringify({ sport_id: sportId });

  return fetch(
    `${RECONCILIATION_TEAMS_URL}/${teamId}`,
    getParams("PUT", jsonData)
  )
    .then((res) => handleResponse(res))
    .then((json) => {
      notice("Team reconciled", "success");
      setterFunction({ team: json });
    })
    .catch((e) => {
      notice(surfaceServerErrors(e, "Error reconciling team"));
      console.error(e.errors);
      throw e;
    });
};
